import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ObjectManagerUtils {
  private createIndexAsKeyObject(object: any, indexParam: string) {
    type ObjectKey = keyof typeof object;
    return indexParam as ObjectKey;
  }

  accessObjectByIndex(object: any, indexParam: string, nullValue: any) {
    const index = this.createIndexAsKeyObject(object, indexParam);
    return object[index] ?? nullValue;
  }

  ternaryValidation(valueValidation: any, valueIfTrue: any, valueIfFalse: any) {
    return valueValidation ? valueIfTrue : valueIfFalse;
  }
}
